import { render, staticRenderFns } from "./MdIcons.vue?vue&type=template&id=84ffd5d0&scoped=true"
import script from "./MdIcons.vue?vue&type=script&lang=js"
export * from "./MdIcons.vue?vue&type=script&lang=js"
import style0 from "./MdIcons.vue?vue&type=style&index=0&id=84ffd5d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84ffd5d0",
  null
  
)

export default component.exports